import { documentTypeUtils } from '@wix/santa-editor-utils';

export default {
  allowedMobileOnly: true,
  skipInQuickEditPanel: true,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};
